import BaseComponent from "../components/BaseComponent";
import {
    Button,
    ModalPage,
    ModalPageHeader,
    ModalRoot,
    Panel,
    PanelHeader, PanelHeaderButton,
    SplitCol,
    SplitLayout,
    View
} from "@vkontakte/vkui";
import MainCatalog from "../catalog/MainCatalog";
import Cart from "../checkout/Cart";
import {Icon24BrowserBack, Icon24ShoppingCartOutline} from "@vkontakte/icons";
import Sclads from "../catalog/Sclads";
import TakeAPhoto from "../components/TakeAPhoto";
import React from "react";
import * as constants from "../assets/constants";
import {AdaptivityContext} from "../assets/constants";
import axios from "axios";
import ParamsFilter from "../catalog/ParamsFilter";

class FragmentOstatki extends BaseComponent {
    constructor(props) {
        super(props)
        const state = {
            activePanelOstatki: 'ostatki_panel',
            current_group_id: constants.DEBUG ? 'c029236a-1b4b-11e6-9f4b-90b11c111c39_group_1' : '',
            current_product: null,
            parent_product_id: null,

            current_filter: [],
            current_filter_items: [],
        }

        this.state = {
            ...this.state,
            ...state
        }
    }

    receiveMessage = (event) => {
        if (event.data == 'cartSaved') {

            this.refreshState()
            return
        }
        if (event.data == 'openParamsFilterModals') {
            this.setActiveModal(constants.MODAL_PARAMS_FILTER)
        }

        if (event.data == 'closeParamsFilterModal') {
            this.setActiveModal(null)
        }

        if (event.data.type !== undefined && event.data.type === 'applyCurrentFilter') {
            this.setState({current_filter: event.data.value.filters, current_filter_items: event.data.value.items})
        }

        if (event.data.type !== undefined && event.data.type === 'applyCurrentFilterItems') {
            this.setState({current_filter_items: event.data.value})
        }

        if (event.data.type !== undefined && event.data.type === 'applyCurrentGroup') {
            this.changeCurrentGroup(event.data.value)
        }

        if (event.data.type !== undefined && event.data.type === 'saveMainSearch') {
            localStorage.setItem(constants.main_search_key, event.data.value)
            return
        }

        if (event.data == 'goGetBack') {

            if (this.state.activePanelOstatki == 'sclads_panel') {
                window.postMessage('scladsGoGetBack')
            } else if (this.state.activePanelOstatki == 'ostatki_panel' && this.state.current_group_id) {
                window.postMessage('ostatkiGoGetBack')
            } else {
                //TO-DO: Кнопка назад работает не корректно
                //this.storyBack()
            }

        }

    }

    changeCurrentGroup = (id) => {
        window.postMessage({type: "applyCurrentFilter", value: {filters: [], items: []}})
        this.setState({current_group_id: id});


    }
    hideSclads = () => {
        this.setState({activePanelOstatki: this.state.lastActivePanelOstatki ?? 'ostatki_panel'});

    }

    changeCurrentProduct = (id) => {
        console.log(id)
        const body = new FormData()
        body.append('product_id', id)
        axios.post(this.state.base_url + '?app=partnersproducts&act=getProduct', body,
            {
                withCredentials: true
            }
        ).then((response) => {


            if (this.props.current_user.meta.settings.no_deny_firm_fit_club != '1' && !this.props.ostatki_club_mode && response.data.product.is_firm_fit == '1') {
                this.openErrorNoty('Это товар из ассортимента FirmFit Club. Пожалуйста перейдите в каталог FirmFit Club для заказа этих товаров')
                return
            }
            if (response.data.product.units.length === 0) {
                this.openErrorNoty('Не найден справочник единиц измереня для товара "' + response.data.product.name + '". Уведомление о данной ошибке уже отправлено в службу' +
                    ' технической поддержки, наши специалисты уже устраняют ее. Данные обновятся в течение 3 часов', 10000)
                axios.get(this.state.base_url + '?app=partnersproducts&act=sendEmptyUnitsNotice&product_id=' + id,
                    {
                        withCredentials: true,
                        headers: {
                            'Content-Type': 'multipart/form-data',

                        }

                    }
                )

                return
            }

            this.setState({current_product: response.data.product});

            //setTimeout(() =>

            if (this.props.activeStory == 'ostatki_story' || this.props.activeStory == 'ostatki_clubs_story') {
                //TO-DO: Очень плохое решение, фрагмент не должен зависить от хозяина. нужно переделать на более Best Practice solution
                this.setState({lastActivePanelOstatki: this.state.activePanelOstatki});
                if (this.props.current_user.is_application == '2') {
                    if (this.state.monitoring_mode) {
                        window.webkit.messageHandlers.takeAPhoto.postMessage('takeAPhoto')
                    } else {
                        this.setState({activePanelOstatki: 'sclads_panel'})
                    }

                } else {
                    this.setState({activePanelOstatki: this.props.monitoring_mode ? 'photo_panel' : 'sclads_panel'});//, 1000);
                }
            }
            if (this.props.activeStory == 'monitoring_create_story') {
                if (this.props.current_user.is_application == '2') {
                    window.webkit.messageHandlers.takeAPhoto.postMessage('takeAPhoto')
                } else {
                    //this.setState({activePanelMonitoring: 'photo_panel'});//, 1000);
                }
            }


        })
    }

    changeParentProductId = (id) => {

        this.setState({parent_product_id: id});
        window.postMessage('clearGetVarsSearch')

    }
    refreshState = () => {
        setTimeout(() => {
            this.setState({})
        }, 500)
    }

    render() {

        const modals = <ModalRoot activeModal={this.state.activeModal}>
            <ModalPage
                id={constants.MODAL_PARAMS_FILTER}
                onClose={this.modalBack}
                settlingHeight={100}
                style={{}}
                header={
                    <ModalPageHeader className="sclads"
                                     before={<PanelHeaderButton
                                         onClick={this.modalBack}><Icon24BrowserBack/></PanelHeaderButton>}

                    >

                    </ModalPageHeader>
                }
            >
                <ParamsFilter base_url={this.state.base_url}
                              username={this.state.username}
                              password={this.state.password}
                              current_group_id={this.state.current_group_id}
                              monitoring_mode={this.state.monitoring_mode}
                              ffc_mode={this.state.ostatki_club_mode}
                              changeCurrentGroup={this.changeCurrentGroup}
                              changeCurrentProduct={this.changeCurrentProduct}
                              current_product={this.state.current_product}

                              parent_product_id={this.state.parent_product_id}
                              changeParentProductId={this.changeParentProductId}

                              get_vars={this.state.get_vars}
                              current_filter={this.state.current_filter}
                              current_filter_items={this.state.current_filter_items}
                              from_modal={true}
                />
            </ModalPage>
        </ModalRoot>
        return <View activePanel={this.state.activePanelOstatki}>
            <Panel id="ostatki_panel">
                <SplitLayout modal={modals}>
                    {AdaptivityContext.isMobile ? '' : this.MainMenu()}
                    <SplitCol width={"25%"}>
                        <MainCatalog base_url={this.state.base_url}
                                     current_user={this.props.current_user}
                                     current_group_id={this.state.current_group_id}
                                     monitoring_mode={this.props.monitoring_mode}
                                     ffc_mode={this.props.ostatki_club_mode}
                                     current_club={this.props.current_club}
                                     changeCurrentGroup={this.changeCurrentGroup}
                                     changeCurrentProduct={this.changeCurrentProduct}
                                     current_product={this.state.current_product}
                                     savedState={this.props.mainCatalogSavedState}
                                     parent_product_id={this.state.parent_product_id}
                                     changeParentProductId={this.changeParentProductId}
                                     saveState={state => window.postMessage({
                                         type: 'setMainState',
                                         value: {mainCatalogSavedState: state}
                                     })}
                                     get_vars={this.props.get_vars}
                                     current_filter={this.state.current_filter}
                                     current_filter_items={this.state.current_filter_items}
                        />

                    </SplitCol>
                    {AdaptivityContext.isMobile ? '' :
                        <SplitCol>
                            <div>
                                <PanelHeader>Корзина</PanelHeader>
                                <Cart user={this.props.current_user}
                                      base_url={this.state.base_url}
                                      refresh={() => this.setState({})}/>

                            </div>
                            <Button before={<Icon24ShoppingCartOutline/>} onClick={() => {
                                this.setActiveModal(null);
                                window.postMessage('goToCart')
                            }} mode="primary" size="l" stretched>
                                Оформить заказ
                            </Button>
                        </SplitCol>}
                </SplitLayout>

            </Panel>

            <Panel id="sclads_panel">
                <SplitLayout>
                    {AdaptivityContext.isMobile ? '' : this.MainMenu()}
                    <SplitCol width={"50%"}>
                        <Sclads base_url={this.state.base_url}

                                hideSclads={this.hideSclads}
                                club_mode={this.props.ostatki_club_mode}

                                current_club={this.props.current_club}

                                product={this.state.current_product}
                                parent_product_id={this.state.parent_product_id}
                                user={this.props.current_user}
                                refreshState={this.refreshState}
                        />
                    </SplitCol>
                    {AdaptivityContext.isMobile ? '' :
                        <SplitCol>
                            <div>
                                <PanelHeader>Корзина</PanelHeader>
                                <Cart user={this.props.current_user}
                                      base_url={this.state.base_url}
                                      refresh={() => this.setState({})}/>

                            </div>
                        </SplitCol>}
                </SplitLayout>

            </Panel>
            <Panel id="photo_panel">
                <SplitLayout>
                    <SplitCol width={"50%"}>
                        <TakeAPhoto hidePhotos={this.hideSclads} url={this.state.url}
                                    openErrorNoty={this.openErrorNoty}/>
                    </SplitCol>
                </SplitLayout>

            </Panel>

        </View>
    }

}

export default FragmentOstatki